/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Hero_OverlineInputs */

const en_cp_hero_overline = /** @type {(inputs: Cp_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP CAMPUS · BUILDER & PROBLEM SOLVER`)
};

const id_cp_hero_overline = /** @type {(inputs: Cp_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP CAMPUS · BUILDER & PROBLEM SOLVER`)
};

/**
* | output |
* | --- |
* | "BYSTEP CAMPUS · BUILDER & PROBLEM SOLVER" |
*
* @param {Cp_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_hero_overline = /** @type {((inputs?: Cp_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_hero_overline(inputs)
	return en_cp_hero_overline(inputs)
});